import * as timelib from "./beacon-timelib.d3.js";

const WIDTH = 2000;
const HEIGHT = 1000;

export default function (timefrom_ms, timespan_ms) {
    const sections_data = timelib.timespanSections(timefrom_ms, timespan_ms);
    d3.select("#beacon-background").selectAll("g").remove();
    const selections = d3.select("#beacon-background").selectAll("g").data(sections_data); //, (d) => d.t + "@" + timespan_ms);

    // the remover section
    selections.exit().remove();

    // the update section
    selections.attr("transform", (d) => "translate(" + d.x + ",0)");

    // the create section
    const timesections = selections
        .enter()
        .append("g")
        //.attr("id", (d) => d.t + "@" + timespan_ms)
        .attr("transform", (d) => "translate(" + d.x + ",0)");

    // create the text field
    timesections
        .append("text")
        .attr("y", 20)
        .text((d) => d.label)
        .attr("class", "title-text");

    timesections
        .append("rect")
        .attr("y", 40)
        .attr("x", 0)
        .attr("fill", (d) => {
            if (d.even === true) return "#d1d1d1";
            if (d.even === false) return "#d6d6d6";
            return "#eee";
        })
        .attr("width", (d) => d.width)
        .attr("height", (d) => HEIGHT);
}
